export const CARD_FLAGS = [
    { id: "visa", name: "Visa", icon: "mdi mdi-credit-card" },
    { id: "mastercard", name: "Mastercard", icon: "mdi mdi-credit-card-outline" },
    { id: "elo", name: "Elo", icon: "mdi mdi-credit-card-settings-outline" },
    { id: "amex", name: "American Express", icon: "mdi mdi-credit-card-multiple" },
    { id: "hipercard", name: "Hipercard", icon: "mdi mdi-credit-card-scan-outline" },
    { id: "pix", name: "PIX", icon: "mdi mdi-qrcode-scan" },
    { id: "diners", name: "Diners", icon: "mdi mdi-credit-card-clock-outline" }
];


export const MOCK_DEFAULT_RATES = (flag) => {
    if (flag === 'pix') return { rate: 0.9 };

    // Mock progressivo para crédito 1 a 12 (como base)
    const creditRates = [];
    for (let i = 1; i <= 12; i++) {
        creditRates.push({
            installments: i,
            rate: parseFloat((2.5 + (i - 1) * 0.4).toFixed(2))
        });
    }

    return {
        debit: 1.5,
        credit: creditRates
    };
};
